// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
// import { Container,Header,Aside,Main,Footer,Row,Col,Icon,Button,Upload,Message, Select,Option,Menu,Submenu,MenuItem,Carousel,CarouselItem,Image,Input,Scrollbar,Divider,Descriptions,DescriptionsItem,Tabs, TabPane,Pagination,Breadcrumb, Steps,Step,BreadcrumbItem,FormItem,Form,CheckboxGroup,Checkbox,Dialog, Loading } from 'element-ui';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// fade/zoom 等
import 'element-ui/lib/theme-chalk/base.css';
import 'element-ui/lib/theme-chalk/display.css';
import locale from 'element-ui/lib/locale/lang/zh-CN'  // 本地中文包

//  引入Echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

//  引入百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'YOUR_APP_KEY'
})
// collapse 展开折叠
// import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

// import i18n from './lang'
import less from 'less'
import router from './router'

Vue.config.productionTip = false

//引入less
Vue.use(less)
Vue.use(ElementUI)
Vue.use( locale )

import './utils/filter'


router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  locale,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js